// /wp-json/mytheme/v1/product-search?q=black

// import $ from 'jquery'

/// html result reference

/* <div class="col-6 col-md-6 col-lg-3">
	<div class="product_container">
		<div class="img_container">
			<img src="http://paradisemarketing.local/wp-content/uploads/2023/06/00153.jpg" alt="" />
		</div>
		<div class="content">
			<h3>
				BareSkin
			</h3>
			<p>
				$5.00
			</p>
		</div>
	</div>
</div> */

class AdvancedSearch {
	//? 1. describe and create/initiate our object

	constructor() {
		//Verables

		this.events()
		this.SearchInput = $('.pm_search')
		this.LoadingSpinner = $('.spinner-border')
		this.ResultContainer = $('.results_row')
		this.NoResults = $('.no_results')
		this.searchBtn = $('.search_btn')
		this.viewAllLink = $('.view_all_link')
		this.startPlaceholder = $('.no_tren')
		this.searchURL = ''

		// make a timer
		this.myTimer = null
	}

	//?events
	events() {
		let myObj = this

		// on load

		// when input is changed
		$('.pm_search').on('keyup', function () {
			// update link
			myObj.updateLink($(this).val())
			// on a min of 3 characters
			if ($(this).val().length > 2) {
				// clear timer
				clearTimeout(myObj.myTimer)
				// start timer
				myObj.myTimer = setTimeout(function () {
					myObj.Search()
				}, 1000)
				myObj.ThinkingState()
			} else {
				clearTimeout(myObj.myTimer)
				myObj.ResultContainer.html('')
				// hide spinner
				myObj.LoadingSpinner.addClass('hide')
			}
		})

		$('.FASDF').on('click', function () {
			// clear search
			myObj.ClearSearch()
		})

		// on click of search button
		$('.search_btn').on('click', function () {
			// if input is empty
			if ($('.pm_search').val() == '') {
				// do nothing
			} else {
				// search
				myObj.RedirectSearch()
			}
		})
		// on enter key press
		$('.pm_search').on('keypress', function (e) {
			if (e.which == 13) {
				// prevent default
				e.preventDefault()
				console.log('enter')
				// if input is empty
				if ($('.pm_search').val() == '') {
					// do nothing
				} else {
					// search
					myObj.RedirectSearch()
				}
			}
		})
	}

	//?methods (function, action...)
	ThinkingState() {
		// clear results

		this.ResultContainer.html('')
		this.LoadingSpinner.removeClass('hide')
		this.NoResults.addClass('hide')
		// hide view all link
		this.viewAllLink.addClass('hide')
		// hide start placeholder
		this.startPlaceholder.addClass('hide')
	}

	Search() {
		let myObj = this

		$.ajax({
			url: '/wp-json/mytheme/v1/product-search?q=' + $('.pm_search').val(),
			type: 'GET',
			success: function (data) {
				console.log('Results :', data)
				myObj.LoadingSpinner.addClass('hide')

				// if no results
				if (data.length == 0) {
					myObj.NoResults.removeClass('hide')
				} else {
					myObj.NoResults.addClass('hide')
					// show view all link

					console.log('data : ', data)
					myObj.GenerateHTML(data)
				}
			},
			error: function (error) {
				console.log('error : ', error)
			},
		})
	}

	RedirectSearch() {
		// generate url
		this.searchURL = '/?s=' + $('.pm_search').val() + '&post_type=product'

		// redirect to url
		window.location.href = this.searchURL
	}

	GenerateHTML(data) {
		// if data is greater than 8 show view all link
		if (data.length > 8) {
			this.viewAllLink.removeClass('hide')
		} else {
			this.viewAllLink.addClass('hide')
		}

		// limit data to 8
		data = data.slice(0, 8)

		// loop through data
		data.forEach((item) => {
			// create html
			let html = `
       
                <a href="${item.link}" class="col-6 col-md-6 col-lg-3">
              
                   
                    <div class="product_container">
                    ${
								item.sale
									? `<span class="onsale search_sale">Sale!</span>`
									: ''
							}
                        <div class="img_container">
                            <img src="${item.image}" alt="" />
                        </div>
                        <div class="content">
                            <h3>
                                ${item.title}
                            </h3>

                        </div>
                    </div>
                </a>
                
            `
			// append to container
			this.ResultContainer.append(html)
		})
	}

	updateLink(value) {
		this.viewAllLink.attr('href', '/?s=' + value + '&post_type=product')
	}

	ClearSearch() {
		// clear input
		this.SearchInput.val('')
		// clear results
		this.ResultContainer.html('')
		// hide spinner
		this.LoadingSpinner.addClass('hide')
		// hide view all link
		this.viewAllLink.addClass('hide')
		// show start placeholder
		this.startPlaceholder.removeClass('hide')
	}
}

export default AdvancedSearch
